/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ level: NonNullable<unknown> }} Doc_Confidence_LabelInputs */

const en_doc_confidence_label = /** @type {(inputs: Doc_Confidence_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.level === "high") return /** @type {LocalizedString} */ (`High confidence`);
	if (i?.level === "medium") return /** @type {LocalizedString} */ (`Medium confidence`);
	if (i?.level === "low") return /** @type {LocalizedString} */ (`Low confidence`);
	return /** @type {LocalizedString} */ (`${i?.level}`)
	
};

const pt_br2_doc_confidence_label = /** @type {(inputs: Doc_Confidence_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.level === "high") return /** @type {LocalizedString} */ (`Alta certeza`);
	if (i?.level === "medium") return /** @type {LocalizedString} */ (`Média certeza`);
	if (i?.level === "low") return /** @type {LocalizedString} */ (`Baixa certeza`);
	return /** @type {LocalizedString} */ (`${i?.level}`)
	
};

/**
* | level | output |
* | --- | --- |
* | "high" | "High confidence" |
* | "medium" | "Medium confidence" |
* | "low" | "Low confidence" |
* | * | "{level}" |
*
* @param {Doc_Confidence_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_confidence_label = /** @type {((inputs: Doc_Confidence_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Confidence_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_confidence_label(inputs)
	return pt_br2_doc_confidence_label(inputs)
});